import React from 'react'
import './header.css'
import { useTranslation } from "react-i18next";

const Header = () => {
  const [t, i18n] = useTranslation("sobre_mi");

  return (
    <div class="SB_header_bg-Black">
      <div class="SB_header">
          <div class="SB_header_titulo fade-in-fwd">
              <h2>{(t('header.sobre-mi'))} <span class="SB_header_tituloNaranja">{(t('header.sobre-mi2'))}</span></h2>
          </div>
          <div class="SB_header_parrafo fade-in-fwd">
              <p>{(t('header.descripcion_1'))}
              {(t('header.descripcion_2'))}<span class="SB_header_parrafoNegritas">{(t('header.descripcion_futuro'))}</span>{(t('header.descripcion_3'))}
              {(t('header.descripcion_4'))}<span class="SB_header_parrafoNegritas">{(t('header.descripcion_el'))}</span>”.</p>
          </div>
          <div class="SB_header_nombre fade-in-fwd">
              <p>Ricardo Salinas</p>
          </div>
        
      </div>
    </div>
  )
}

export default Header
